import { E_Colors } from '@/helpers/colors'
import styled from 'styled-components'


export const SC_FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 24px;
  margin-bottom: 12px;
`

export const SC_CheckboxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-bottom: 24px;
`

export const SC_DocLink = styled.span`
  color: ${E_Colors.TextPrimary};
  cursor: pointer;
`